<template>
  <basic-container>
    <avue-crud
        :option="option"
        :data="data"
        :page.sync="page"
        ref="crud"
        @row-del="rowDel"
        v-model="form"
        :permission="permissionList"
        @row-update="rowUpdate"
        @row-save="rowSave"
        :before-open="beforeOpen"
        @search-change="searchChange"
        @refresh-change="refreshChange"
        @selection-change="selectionChange"
        @on-load="onLoad">
      <!-- <template slot-scope="scope" slot="menu">
        <el-button type="text" size="small"
                @click.stop="handleDetail1(scope.row,scope.index)">睡眠改善详情
        </el-button>
      </template> -->
    </avue-crud>
  </basic-container>
</template>

<script>
import { getList1, getDetail, submit, remove } from '@/api/health/GuidanceSleepDiaryKnowledge'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      params1: {
        status: 3,
        head: ''
      },
      params: {
        head: ''
      },
      selectionList: [],
      option: {
        searchMenuSpan: 12,
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        addBtn: true,
        delBtn: true,
        editBtn: true,
        selection: false,
        align: 'center',
        column: [
          {
            label: '标题名称',
            prop: 'title',
            search: true
          },
          {
            label: '详情',
            prop: 'details',
            search: true
          },
          {
            label: '创建时间',
            prop: 'createTime',
            addDisplay: false,
            editDisabled: true,
            span: 24,
            cell: false
          },
          {
            label: '修改时间',
            prop: 'updateTime',
            addDisplay: false,
            editDisabled: true,
            span: 24,
            cell: false
          }
        ]
      },
      data: []
    }
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList () {
      return {
        addBtn: this.permission.shop_order_add,
        viewBtn: this.permission.shop_order_view,
        delBtn: this.permission.shop_order_delete,
        editBtn: this.permission.shop_order_edit
      }
    },
    ids () {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  created () {
    this.head = this.$route.query.head
    this.params1.head = this.$route.query.head || ''
    this.onLoad()
  },
  methods: {
    handleDetail1 (data) {
      this.$router.push({
        path: '/digitManage/GuidanceSleepDiaryImproveDeatils',
        query: { head: data.head }
      })
    },
    rowSave (row, done, loading) {
      row.head = this.head
      row.type = 1
      submit(row).then(() => {
        done()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }).catch(() => {
        loading()
      })
    },
    rowUpdate (row, index, done, loading) {
      submit(row).then(() => {
        done()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }).catch(() => {
        loading()
      })
    },
    rowDel (row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return remove(row.id)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        })
    },
    searchReset () {
      this.onLoad(this.page)
    },
    searchChange (params, done) {
      console.log('test searchChange')
      console.log(params)
      console.log(this.params1)
      this.params1 = params
      this.params1.status = 3
      console.log(this.params1)
      this.onLoad(this.page)
      done()
    },
    selectionChange (list) {
      this.selectionList = list
    },
    refreshChange (data) {
      console.log('test')
      console.log(data)
      console.log(this.params1)
      this.params1 = data.searchForm
      this.params1.status = 3
      console.log(this.params1)
      this.onLoad(this.page)
    },
    handleDelete () {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return remove(this.ids)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.$refs.crud.toggleSelection()
        })
    },

    beforeOpen (done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data
        })
      }
      done()
    },
    onLoad (page) {
      getList1(this.page.currentPage, this.page.pageSize, this.params1).then(res => {
        console.log('test')
        console.log(res)
        const data = res.data
        for (const key in data.records) {
          if (data.records[key].type === 0) {
            data.records.splice(key, 1)
          }
        }
        this.page.total = data.total
        this.data = data.records
      })
    }
  }
}
</script>
